<template>
  <router-view></router-view>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "app",
  created() {
    window.addEventListener('message', (e) => {
      // message that was passed from iframe page
      let message = e.data;
      if (message.type === 'keycloak-auth' && message.code) {
        this.$store.dispatch("dismissModal");
        this.$auth
            .login({
              data: {
                redirect: window.location.href.split("/").slice(0,3).join("/"),
                code: message.code,
              },
            })
            .then(() => {
              this.loadFavorites();
            })
            .catch((error) => {
              this.$notify({
                message: error.response.data.message,
                title: "Ошибка!",
                timeout: 5000,
                custom: true,
                type: "danger",
              });
              this.$router.push({ name: "forbidden" });
            });
      } else if (message.message === 'resize-frame') {
        window.document.getElementById('CalcFrame').style.height = message.height + 'px';
      }
    } , false);

    setTimeout( () => {
      if (this.$auth.check()) {
        Echo.join("online").leaving((user) => {
          self.axios.post("offline-user", { id: user.id });
        });
        Echo.join("online.user." + this.$auth.user().id);
        Echo.join("online.organization." + this.$auth.user().organization_id);
        Echo.join("online.region." + this.$auth.user().region_id);
      }
    }, 7000);
  },
  methods: {
    ...mapActions({
      loadFavorites: "loadFavorites"
    }),
  },
};
</script>

<style lang="scss">
@import "./scss/style.scss";
</style>
